import styled from '@xstyled/styled-components';

/**
 * Visually hidden but kept in the accessibility tree.
 * Do not use global `.sr-only` here — it sets `visibility: hidden`,
 * which VoiceOver / Chrome a11y skip (see ComboButton LiveStatus).
 */
const visuallyHiddenCss = `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const VisuallyHidden = styled.span`
  ${visuallyHiddenCss}
`;

/** Same styles, but a real <legend> for fieldset naming (EL–E25 / EL–E28). */
export const VisuallyHiddenLegend = styled.legend`
  ${visuallyHiddenCss}
`;
